import React, {Component} from "react";
import {
  DKLabel,
  DKButton,
  DKIcons,
  DKIcon, showAlert, showLoader, removeLoader, showToast, TOAST_TYPE,
} from "deskera-ui-library";
import ContactService from "../../../services/contact";
import Utility, {getRandomNumber} from "../../../utility/Utility";
import { scrollToError } from "../../../managers/common/CommonUtil";

/*
PROPS
- header
- onCancel
- data
- onSave (options)
*/

class FormFieldSelectOptions extends Component {
  constructor(props) {
    super(props);
    let data = props.data ? Utility.makeCopyOfObject(props.data) : undefined
    this.state = {
      options: data ? ([...data.options] || []) : this.getDefaultOptions(),
      needSaveOption: false
    };
  }

  componentDidMount() {
    scrollToError("options-popup-id");
  }

  render() {
    return (
      <div className={`transparent-background transparent-background-options options-popup-id bg-trans`}>
        <div style={{width: "250px"}} className="popup-window justify-content-center align-items-center p-xl">
          <div className="row justify-content-center">
            <DKIcon
              src={DKIcons.data_type.ic_multi_select}
              className="ic-s mr-r"
            />
            <DKLabel text={this.props.header} className="fw-m fs-xl"/>
          </div>
          <div style={{maxHeight: 400, overflowY: "scroll"}} className="mt-xl pt-m hide-scroll-bar">
            {this.getOptions()}
          </div>
          <div className="row-reverse mb-l mt-l">
            <DKButton
              title="+ Add New"
              onClick={this.addOptions}
              className="bg-app text-white "
            />
          </div>
          {this.getFooter()}
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getDefaultOptions() {
    return [{id: this.getRandomOptionId(), name: "Option1", color: "data-grid-badge-color-1"},
      {id: this.getRandomOptionId(), name: "Option2", color: "data-grid-badge-color-1"}]
  }

  getOptions() {
    let arr = [];
    this.state.options.forEach((item, index) => {
      arr.push(this.getItemRow(item, index));
    });
    return arr;
  }

  getItemRow(item, index) {
    return (
      <div key={index} className="row mb-l">
        <div className="column  ml-xs parent-width ">
          <div className="row">
            <input
              className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m "
              type="text"
              value={item.name}
              onChange={(e) => this.changeValue("name", e.target.value, index)}
              placeholder="Option Name"
            />
            <DKButton
              className="bg-gray1 border-m ml-r"
              icon={DKIcons.ic_delete}
              onClick={() => this.deleteOption(index)}
            />
          </div>
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  deleteOption = (index) => {
    if (this.state.options?.length === 1) {
      showAlert("Alert", "Atleast 1 option is required.")
      return
    }
    this.setShowSaveOptions(true)
    let value = this.state.options;
    value.splice(index, 1);
    this.setSelectOptions(value)
  };

  changeValue = (property, value, index) => {
    this.setShowSaveOptions(true)
    let new_value = [...this.state.options] || [];
    new_value[index][property] = value;
    this.setSelectOptions(new_value)
  };

  addOptions = () => {
    this.setShowSaveOptions(true)
    const value = this.state.options || [];
    const noOfOptions = (value.length || 0) + 1
    const newOption = {id: this.getRandomOptionId(), name: "Option" + noOfOptions, color: "data-grid-badge-color-1"}
    value.push(newOption)
    this.setSelectOptions(value)
  };

  setSelectOptions = (data) => {
    this.setState({options: data});
  };

  setShowSaveOptions = (flag) => {
    this.setState({needSaveOption: flag});
  };

  showSaveOption = () => {
    if (this.props.data !== undefined && !this.state.needSaveOption) {
      return false
    }
    return true
  }

  getRandomOptionId() {
    return parseInt(getRandomNumber() + "" + (this.state ? (this.state.options || []).length : 0));
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  cancelTapped = () => {
    this.props.onCancel();
  };

  saveTapped = () => {
    let isOptionsNameMissing = (this.state.options || []).find(item => item.name?.trim().length === 0)
    if (!isOptionsNameMissing) {
      if (this.props.data) {
        let updatedOptions = {...this.props.data, options: this.state.options}
        this.updateFieldOptions(updatedOptions)
      } else {
        this.props.onSave(this.state.options);
      }
    } else {
      showAlert("Alert", "Please check option's name")
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  updateFieldOptions(fieldData) {
    showLoader("Updating... Please wait");
    ContactService.updateColumn(fieldData, (response) => {
      const {data} = response
      if (data.id) {
        showToast("Options updated successfully", TOAST_TYPE.SUCCESS);
        this.updateTableData()
        this.props.onSave(this.state.options, fieldData);
      } else {
        removeLoader()
      }
    }, (error) => {
      removeLoader()
    })
  }

  updateTableData() {
    ContactService.setTableColumns(() => {
      removeLoader()
    }, (error) => {
      removeLoader()
    })
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getFooter() {
    return (
      <div className="row justify-content-center">
        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={this.cancelTapped}
        />
        {<DKButton
          title="Save"
          className="bg-app text-white ml-m"
          onClick={this.saveTapped}
        />}
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export default FormFieldSelectOptions;
